import { LocalizationKeys, type Translations } from "../keys";
import { ruRegionTranslations } from "./regions/ru";

export const ruTranslations: Translations = {
  [LocalizationKeys.COMMON_LOADING]: "Загрузка...",
  [LocalizationKeys.COMMON_ERROR]: "Ошибка",
  [LocalizationKeys.COMMON_SAVE]: "Сохранить",
  [LocalizationKeys.COMMON_CANCEL]: "Отмена",
  [LocalizationKeys.COMMON_DELETE]: "Удалить",
  [LocalizationKeys.COMMON_DELETING]: "Удаление...",
  [LocalizationKeys.COMMON_YES]: "Да",
  [LocalizationKeys.COMMON_EDIT]: "Редактировать",
  [LocalizationKeys.COMMON_BACK]: "Назад",
  [LocalizationKeys.COMMON_NO_RESULTS]: "Нет результатов",
  [LocalizationKeys.COMMON_VIEW_ALL]: "Показать все",
  [LocalizationKeys.COMMON_RESULT]: "результат",
  [LocalizationKeys.COMMON_RESULTS]: "результатов",

  // View mode keys
  [LocalizationKeys.VIEW_MODE_TOGGLE]: "Переключить режим отображения",
  [LocalizationKeys.VIEW_MODE_GRID]: "Сетка",
  [LocalizationKeys.VIEW_MODE_LIST]: "Список",

  // Text editor keys
  [LocalizationKeys.TEXT_EDITOR_BOLD]: "Жирный (Ctrl+B)",
  [LocalizationKeys.TEXT_EDITOR_ITALIC]: "Курсив (Ctrl+I)",
  [LocalizationKeys.TEXT_EDITOR_UNDERLINE]: "Подчёркнутый (Ctrl+U)",
  [LocalizationKeys.TEXT_EDITOR_STRIKETHROUGH]: "Зачёркнутый",
  [LocalizationKeys.TEXT_EDITOR_HEADING]: "Заголовок",
  [LocalizationKeys.TEXT_EDITOR_QUOTE]: "Цитата",
  [LocalizationKeys.TEXT_EDITOR_LIST]: "Список",
  [LocalizationKeys.TEXT_EDITOR_LINK]: "Ссылка",
  [LocalizationKeys.TEXT_EDITOR_PLACEHOLDER]: "Введите текст...",
  [LocalizationKeys.TEXT_EDITOR_PREVIEW]: "Предпросмотр",

  [LocalizationKeys.HEADER_SEARCH]: "Поиск...",
  [LocalizationKeys.HEADER_NOTIFICATIONS]: "Уведомления",
  [LocalizationKeys.HEADER_PROFILE]: "Профиль",

  [LocalizationKeys.AUTH_SIGN_IN]: "Войти",
  [LocalizationKeys.AUTH_SIGN_UP]: "Зарегистрироваться",
  [LocalizationKeys.AUTH_LOGOUT]: "Выйти",
  [LocalizationKeys.AUTH_EMAIL]: "Email",
  [LocalizationKeys.AUTH_PASSWORD]: "Пароль",
  [LocalizationKeys.AUTH_USERNAME]: "Имя пользователя",
  [LocalizationKeys.AUTH_PROMPT_MESSAGE]: "Войдите, чтобы отслеживать прогресс",
  [LocalizationKeys.AUTH_PROMPT_TITLE]:
    "Эта функция доступна только зарегистрированным пользователям",
  [LocalizationKeys.AUTH_PROMPT_SUBTITLE]:
    "Присоединяйтесь — с аккаунтом вы сможете:",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_TRACK]:
    "Отмечать что посмотрели, читали или прошли — и не терять из виду",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_REVIEWS]:
    "Писать рецензии и делиться впечатлениями",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_COLLECTIONS]:
    "Собирать подборки: «Лучшее за выходные», «На вечер» и любые другие",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_DISCUSS]:
    "Обсуждать новинки и делиться теориями",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_NOTIFICATIONS]:
    "Получать уведомления о новых сериях и релизах",
  [LocalizationKeys.AUTH_PROMPT_FEATURE_SOCIAL]:
    "Подписываться на друзей и следить за их рекомендациями",

  [LocalizationKeys.COMMON_CLOSE]: "Закрыть",

  [LocalizationKeys.PROFILE_OPEN_PROFILE]: "Открыть профиль",
  [LocalizationKeys.PROFILE_THEME]: "Тема",
  [LocalizationKeys.PROFILE_LANGUAGE]: "Язык",
  [LocalizationKeys.PROFILE_SETTINGS]: "Настройки",

  [LocalizationKeys.MENU_SELECT_THEME]: "Выбрать тему",
  [LocalizationKeys.MENU_SELECT_LANGUAGE]: "Выбрать язык",
  [LocalizationKeys.MENU_BACK_TO_MENU]: "Назад в меню",
  [LocalizationKeys.MENU_LANGUAGE_CHANGED]: "Язык изменён (изменения не сохраняются на сервер)",
  [LocalizationKeys.MENU_THEME_CHANGED]: "Тема изменена (изменения не сохраняются на сервер)",

  [LocalizationKeys.THEME_LIGHT]: "Светлая",
  [LocalizationKeys.THEME_DARK]: "Темная",
  [LocalizationKeys.THEME_SYSTEM]: "Авто",

  [LocalizationKeys.LANGUAGE_SYSTEM]: "Авто",
  [LocalizationKeys.LANGUAGE_RU]: "Русский",
  [LocalizationKeys.LANGUAGE_EN]: "English",
  [LocalizationKeys.LANGUAGE_ES]: "Español",
  [LocalizationKeys.LANGUAGE_FR]: "Français",
  [LocalizationKeys.LANGUAGE_DE]: "Deutsch",
  [LocalizationKeys.LANGUAGE_ZH]: "中文",
  [LocalizationKeys.LANGUAGE_IN]: "हिन्दी",
  [LocalizationKeys.LANGUAGE_PT]: "Português",

  [LocalizationKeys.CONSUME_TYPE_UNSPECIFIED]: "Не смотрел",
  [LocalizationKeys.CONSUME_TYPE_WATCHING]: "Смотрю",
  [LocalizationKeys.CONSUME_TYPE_WATCHED]: "Просмотрено",
  [LocalizationKeys.CONSUME_TYPE_DELAYED]: "Отложено",
  [LocalizationKeys.CONSUME_TYPE_TRASH]: "Брошено",

  [LocalizationKeys.GENDER_UNSPECIFIED]: "Не указан",
  [LocalizationKeys.GENDER_MALE]: "Мужской",
  [LocalizationKeys.GENDER_FEMALE]: "Женский",
  [LocalizationKeys.GENDER_OTHER]: "Другой",

  [LocalizationKeys.CONTENT_TYPE_UNSPECIFIED]: "Не указан",
  [LocalizationKeys.CONTENT_TYPE_MOVIE]: "Фильм",
  [LocalizationKeys.CONTENT_TYPE_BOOK]: "Книга",
  [LocalizationKeys.CONTENT_TYPE_TV_SHOW]: "Сериал",
  [LocalizationKeys.CONTENT_TYPE_COMICS]: "Комикс",
  [LocalizationKeys.CONTENT_TYPE_GAME]: "Игра",

  [LocalizationKeys.CONTENT_STATUS_COMPLETED]: "Завершено",
  [LocalizationKeys.CONTENT_STATUS_PLANNED]: "Запланировано",
  [LocalizationKeys.CONTENT_STATUS_IN_PROGRESS]: "В процессе",
  [LocalizationKeys.CONTENT_STATUS_CANCELLED]: "Отменено",

  [LocalizationKeys.NAV_MOVIES]: "Фильмы",
  [LocalizationKeys.NAV_TV_SHOWS]: "Сериалы",
  [LocalizationKeys.NAV_GAMES]: "Игры",
  [LocalizationKeys.NAV_BOOKS]: "Книги",
  [LocalizationKeys.NAV_COMICS]: "Комиксы",
  [LocalizationKeys.NAV_COLLECTIONS]: "Коллекции",
  [LocalizationKeys.NAV_REVIEWS]: "Отзывы",
  [LocalizationKeys.NAV_FAVORITES]: "Избранное",
  [LocalizationKeys.NAV_HISTORY]: "История",
  [LocalizationKeys.NAV_SETTINGS]: "Настройки",
  [LocalizationKeys.NAV_ABOUT]: "О приложении",

  [LocalizationKeys.A_SEARCH_BUTTON]: "Смотреть результаты",
  [LocalizationKeys.A_SEARCH_CATEGORY]: "Категория",
  [LocalizationKeys.A_SEARCH_GENRE]: "Жанр",
  [LocalizationKeys.A_SEARCH_NAME]: "Название",
  [LocalizationKeys.A_SEARCH_NAME_PLACEHOLDER]: "Введите название контента",
  [LocalizationKeys.A_SEARCH_NAME_LABEL]: "Фильтр по названию контента",
  [LocalizationKeys.A_SEARCH_RELEASE_DATE]: "Дата релиза",
  [LocalizationKeys.A_SEARCH_DATE_FROM_PLACEHOLDER]: "С",
  [LocalizationKeys.A_SEARCH_DATE_FROM_LABEL]: "Дата релиза с",
  [LocalizationKeys.A_SEARCH_DATE_TO_PLACEHOLDER]: "По",
  [LocalizationKeys.A_SEARCH_DATE_TO_LABEL]: "Дата релиза по",
  [LocalizationKeys.A_SEARCH_RATING]: "Рейтинг",
  [LocalizationKeys.A_SEARCH_RATING_RANGE]: "Диапазон рейтинга",
  [LocalizationKeys.A_SEARCH_RATING_PLATFORM_PLACEHOLDER]: "Выберите платформу",
  [LocalizationKeys.A_SEARCH_RATING_PLATFORM_LABEL]: "Платформа рейтинга",
  [LocalizationKeys.A_SEARCH_RATING_FROM_PLACEHOLDER]: "От",
  [LocalizationKeys.A_SEARCH_RATING_FROM_LABEL]: "Рейтинг от",
  [LocalizationKeys.A_SEARCH_RATING_TO_PLACEHOLDER]: "До",
  [LocalizationKeys.A_SEARCH_RATING_TO_LABEL]: "Рейтинг до",
  [LocalizationKeys.A_SEARCH_RATING_INVALID_FORMAT]:
    "Неверный рейтинг. Введите число от 0 до 10",
  [LocalizationKeys.A_SEARCH_COUNTRY]: "Страна",
  [LocalizationKeys.A_SEARCH_COUNTRY_PLACEHOLDER]: "Выберите страну",
  [LocalizationKeys.A_SEARCH_COUNTRY_LABEL]: "Фильтр по стране",
  [LocalizationKeys.A_SEARCH_DURATION]: "Продолжительность",
  [LocalizationKeys.A_SEARCH_DURATION_FROM_PLACEHOLDER]: "От",
  [LocalizationKeys.A_SEARCH_DURATION_FROM_LABEL]: "Продолжительность от",
  [LocalizationKeys.A_SEARCH_DURATION_TO_PLACEHOLDER]: "До",
  [LocalizationKeys.A_SEARCH_DURATION_TO_LABEL]: "Продолжительность до",
  [LocalizationKeys.A_SEARCH_DURATION_INVALID_FORMAT]:
    "Неверная продолжительность. Введите положительное число",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS]: "Участники",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_PLACEHOLDER]:
    "Поиск актера, режиссера и т.д.",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_LABEL]: "Фильтр по участникам",
  [LocalizationKeys.A_SEARCH_PARTICIPANTS_MIN_CHARS]:
    "Введите минимум 3 символа для поиска",
  [LocalizationKeys.A_SEARCH_FILTERS_TITLE]: "Фильтры поиска:",
  [LocalizationKeys.A_SEARCH_EXPAND_ALL]: "Развернуть все",
  [LocalizationKeys.A_SEARCH_COLLAPSE_ALL]: "Свернуть все",
  [LocalizationKeys.A_SEARCH_STATUS]: "Статус",
  [LocalizationKeys.A_SEARCH_EMPTY_PLACEHOLDER]:
    'Выберите фильтры и нажмите "Смотреть результаты"',
  [LocalizationKeys.A_SEARCH_EMPTY_RESULTS]: "Ничего не найдено. Попробуйте изменить фильтры.",
  [LocalizationKeys.A_SEARCH_CLEAR_FILTERS]: "Очистить всё",

  [LocalizationKeys.GENRE_UNSPECIFIED]: "Не указано",
  [LocalizationKeys.GENRE_ACTION]: "Боевик",
  [LocalizationKeys.GENRE_ADVENTURE]: "Приключения",
  [LocalizationKeys.GENRE_ANIMATION]: "Анимация",
  [LocalizationKeys.GENRE_BIOGRAPHY]: "Биография",
  [LocalizationKeys.GENRE_COMEDY]: "Комедия",
  [LocalizationKeys.GENRE_CRIME]: "Криминал",
  [LocalizationKeys.GENRE_DOCUMENTARY]: "Документальный",
  [LocalizationKeys.GENRE_DRAMA]: "Драма",
  [LocalizationKeys.GENRE_FAMILY]: "Семейный",
  [LocalizationKeys.GENRE_FANTASY]: "Фэнтези",
  [LocalizationKeys.GENRE_FILM_NOIR]: "Нуар",
  [LocalizationKeys.GENRE_GAME_SHOW]: "Игровое шоу",
  [LocalizationKeys.GENRE_HISTORY]: "Исторический",
  [LocalizationKeys.GENRE_HORROR]: "Ужасы",
  [LocalizationKeys.GENRE_MUSIC]: "Музыка",
  [LocalizationKeys.GENRE_MUSICAL]: "Мюзикл",
  [LocalizationKeys.GENRE_NEWS]: "Новости",
  [LocalizationKeys.GENRE_REALITY_TV]: "Реалити-шоу",
  [LocalizationKeys.GENRE_ROMANCE]: "Романтика",
  [LocalizationKeys.GENRE_SCI_FI]: "Научная фантастика",
  [LocalizationKeys.GENRE_SHORT]: "Короткометражка",
  [LocalizationKeys.GENRE_SPORT]: "Спорт",
  [LocalizationKeys.GENRE_TALK_SHOW]: "Ток-шоу",
  [LocalizationKeys.GENRE_THRILLER]: "Триллер",
  [LocalizationKeys.GENRE_WAR]: "Военный",
  [LocalizationKeys.GENRE_WESTERN]: "Вестерн",

  [LocalizationKeys.PLATFORM_UNSPECIFIED]: "Не указано",
  [LocalizationKeys.PLATFORM_IMDB]: "IMDb",
  [LocalizationKeys.PLATFORM_KINOPOISK]: "Кинопоиск",

  [LocalizationKeys.SEARCH_ALL]: "Все",
  [LocalizationKeys.SEARCH_CONTENT]: "Контент",
  [LocalizationKeys.SEARCH_MOVIES]: "Фильмы",
  [LocalizationKeys.SEARCH_TV_SHOWS]: "Сериалы",
  [LocalizationKeys.SEARCH_BOOKS]: "Книги",
  [LocalizationKeys.SEARCH_COMICS]: "Комиксы",
  [LocalizationKeys.SEARCH_GAMES]: "Игры",
  [LocalizationKeys.SEARCH_USERS]: "Пользователи",
  [LocalizationKeys.SEARCH_PERSONS]: "Персоны",
  [LocalizationKeys.SEARCH_COLLECTIONS]: "Коллекции",
  [LocalizationKeys.SEARCH_FAVORITES]: "Избранное",
  [LocalizationKeys.SEARCH_USER]: "Пользователь",
  [LocalizationKeys.SEARCH_COMMUNITY]: "Сообщество",
  [LocalizationKeys.SEARCH_SEARCHING]: "Поиск...",
  [LocalizationKeys.SEARCH_NO_RESULTS]: "Ничего не найдено",
  [LocalizationKeys.SEARCH_USER_REPUTATION]: "Репутация",

  [LocalizationKeys.NOTIFICATION_JUST_NOW]: "Только что",
  [LocalizationKeys.NOTIFICATION_MINUTES_AGO]: "{0} мин назад",
  [LocalizationKeys.NOTIFICATION_HOURS_AGO]: "{0} ч назад",
  [LocalizationKeys.NOTIFICATION_DAYS_AGO]: "{0} дн назад",
  [LocalizationKeys.NOTIFICATION_WEEKS_AGO]: "{0} нед назад",
  [LocalizationKeys.NOTIFICATION_MONTHS_AGO]: "{0} мес назад",
  [LocalizationKeys.NOTIFICATION_YEARS_AGO]: "{0} г назад",
  [LocalizationKeys.NOTIFICATION_MARK_ALL_READ]: "Отметить все прочитанными",
  [LocalizationKeys.NOTIFICATION_NO_NEW]: "Нет новых уведомлений",
  [LocalizationKeys.NOTIFICATION_UNREAD_COUNT]: "{0} непрочитанное уведомление",
  [LocalizationKeys.NOTIFICATION_EMPTY_STATE]:
    "Уведомления появятся здесь, когда они поступят.",
  [LocalizationKeys.NOTIFICATION_LOADING_MORE]: "Загрузка...",
  [LocalizationKeys.NOTIFICATION_LOAD_ERROR]:
    "Не удалось загрузить уведомления",

  // Favourites action keys
  [LocalizationKeys.FAVOURITES_FAVOURITE]: "Избранное",
  [LocalizationKeys.FAVOURITES_MUTE]: "Без уведомлений",
  [LocalizationKeys.FAVOURITES_UNMUTE]: "С уведомлениями",
  [LocalizationKeys.FAVOURITES_UNFAVOURITE]: "Убрать из избранного",

  // Add to collection popup keys
  [LocalizationKeys.ADD_TO_COLLECTION_TITLE]:
    "Выберите коллекцию, в которую хотите добавить этот контент",
  [LocalizationKeys.ADD_TO_COLLECTION_CREATE_NEW]: "Создать новую коллекцию",
  [LocalizationKeys.CREATE_COLLECTION_TITLE]: "Создать новую коллекцию",
  [LocalizationKeys.CREATE_COLLECTION_BUTTON]: "Создать",
  [LocalizationKeys.ADD_TO_COLLECTION_NO_COLLECTIONS]:
    "У вас пока нет коллекций",
  [LocalizationKeys.ADD_TO_COLLECTION_LOADING]: "Загрузка коллекций...",
  [LocalizationKeys.ADD_TO_COLLECTION_ERROR]: "Не удалось загрузить коллекции",
  [LocalizationKeys.ADD_TO_COLLECTION_SUCCESS]: "Контент добавлен в коллекцию",

  // Collection item keys
  [LocalizationKeys.COLLECTION_AUTHOR_NOTE]: "Заметка автора",
  [LocalizationKeys.COLLECTION_NOTE_PLACEHOLDER]:
    "Добавьте заметку к этому элементу...",

  // Collection form keys
  [LocalizationKeys.COLLECTION_TITLE]: "Название коллекции",
  [LocalizationKeys.COLLECTION_TITLE_PLACEHOLDER]: "Введите название коллекции",
  [LocalizationKeys.COLLECTION_DESCRIPTION]: "Описание",
  [LocalizationKeys.COLLECTION_DESCRIPTION_PLACEHOLDER]:
    "Опишите вашу коллекцию...",
  [LocalizationKeys.COLLECTION_IMAGE_URL]: "URL обложки",
  [LocalizationKeys.COLLECTION_IMAGE_URL_PLACEHOLDER]:
    "https://example.com/image.jpg",

  // Collection delete keys
  [LocalizationKeys.COLLECTION_DELETE_TITLE]: "Удаление коллекции",
  [LocalizationKeys.COLLECTION_DELETE_CONFIRM_MESSAGE]:
    "Вы уверены, что хотите удалить эту коллекцию? Это действие нельзя отменить.",

  [LocalizationKeys.CONTENT_DETAILS_PIN_CONTENT]: "Закрепить контент",
  [LocalizationKeys.CONTENT_DETAILS_ADD_TO_COLLECTION]: "В коллекцию",
  [LocalizationKeys.CONTENT_DETAILS_CHANGE_CONSUME_TYPE]:
    "Изменить тип потребления",
  [LocalizationKeys.CONTENT_DETAILS_TOGGLE_FAVOURITE]: "В избранное",
  [LocalizationKeys.CONTENT_DETAILS_OPEN_DISCUSSION]: "Обсудить",
  [LocalizationKeys.CONTENT_DETAILS_OPEN_SETTINGS]: "Настройки",
  [LocalizationKeys.CONTENT_DETAILS_RATE_CONTENT]: "Оценить контент",
  [LocalizationKeys.CONTENT_DETAILS_EXTERNAL_RATINGS]: "Внешние рейтинги",
  [LocalizationKeys.CONTENT_DETAILS_CHILD_CONTENT]: "Дочерний контент",
  [LocalizationKeys.CONTENT_DETAILS_REVIEWS]: "Отзывы",
  [LocalizationKeys.CONTENT_DETAILS_COLLECTIONS]: "Коллекции",
  [LocalizationKeys.CONTENT_DETAILS_PARTICIPANTS]: "Участники",
  [LocalizationKeys.CONTENT_DETAILS_GENRES]: "Жанры",
  [LocalizationKeys.CONTENT_DETAILS_YOUR_RATING]: "Ваша оценка",
  [LocalizationKeys.CONTENT_DETAILS_COMMUNITY_RATING]: "Наша оценка",
  [LocalizationKeys.CONTENT_DETAILS_RATE_THIS]: "Оцените это",
  [LocalizationKeys.CONTENT_DETAILS_REVIEWS_COUNT]: "{0} отзывов",
  [LocalizationKeys.CONTENT_DETAILS_DESCRIPTION]: "Описание",
  [LocalizationKeys.CONTENT_DETAILS_CONTINUE]: "Продолжить ➜",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_MINUTES]: "минут",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_HOURS]: "часов",
  [LocalizationKeys.CONTENT_DETAILS_DURATION_PAGES]: "страниц",
  [LocalizationKeys.CONTENT_DETAILS_RELEASE_DATE]: "Дата релиза",
  [LocalizationKeys.CONTENT_DETAILS_STATUS]: "Статус",
  [LocalizationKeys.CONTENT_DETAILS_CERTIFICATE]: "Возрастное ограничение",
  [LocalizationKeys.CONTENT_DETAILS_EPISODE_COUNT]: "Количество эпизодов",
  [LocalizationKeys.CONTENT_DETAILS_AVG_EPISODE_DURATION]:
    "Средняя длительность эпизода",

  // Context menu keys
  [LocalizationKeys.CONTEXT_MENU_PIN]: "Закрепить",
  [LocalizationKeys.CONTEXT_MENU_UNPIN]: "Открепить",
  [LocalizationKeys.CONTEXT_MENU_FAVOURITE]: "Избранное",
  [LocalizationKeys.CONTEXT_MENU_CONSUME]: "Просмотр",
  [LocalizationKeys.CONTEXT_MENU_SHARE]: "Поделиться",
  [LocalizationKeys.CONTEXT_MENU_REPORT]: "Пожаловаться",
  [LocalizationKeys.CONTEXT_MENU_LOGOUT]: "Выйти",

  // Affiliate settings keys
  [LocalizationKeys.AFFILIATE_SETTINGS_TITLE]: "Настройки контента",
  [LocalizationKeys.AFFILIATE_SETTINGS_LINK]: "Ссылка на контент",
  [LocalizationKeys.AFFILIATE_SETTINGS_LINK_PLACEHOLDER]: "Введите ссылку",
  [LocalizationKeys.AFFILIATE_SETTINGS_VARIANT]: "Вариант",
  [LocalizationKeys.AFFILIATE_SETTINGS_VARIANT_PLACEHOLDER]:
    "Озвучка / Издание",
  [LocalizationKeys.AFFILIATE_SETTINGS_SAVE]: "Сохранить",
  [LocalizationKeys.AFFILIATE_SETTINGS_CANCEL]: "Отмена",

  // Navigator keys
  [LocalizationKeys.NAVIGATOR_TITLE]: "Навигатор",
  [LocalizationKeys.NAVIGATOR_EXPAND_ALL]: "Развернуть все",
  [LocalizationKeys.NAVIGATOR_COLLAPSE_ALL]: "Свернуть все",
  [LocalizationKeys.NAVIGATOR_EXPAND]: "Развернуть",
  [LocalizationKeys.NAVIGATOR_COLLAPSE]: "Свернуть",
  [LocalizationKeys.NAVIGATOR_MARK_WATCHED]: "Отметить просмотренным",
  [LocalizationKeys.NAVIGATOR_RATE]: "Оценить",

  // Reviews keys
  [LocalizationKeys.REVIEWS_USER_HAS_REVIEW]:
    "У вас ещё нет отзывов на этот контент. Вы можете поделиться своими впечатлениями, написав отзыв!",
  [LocalizationKeys.REVIEWS_NO_REVIEWS]: "На этот контент нет отзывов.",
  [LocalizationKeys.REVIEWS_WRITE_REVIEW]: "Написать отзыв",
  [LocalizationKeys.REVIEWS_SAVE]: "Сохранить отзыв",
  [LocalizationKeys.REVIEWS_CANCEL]: "Отмена",
  [LocalizationKeys.REVIEWS_PLACEHOLDER]:
    "Поделитесь своими впечатлениями об этом контенте...",
  [LocalizationKeys.REVIEWS_FORMATTING_BOLD]: "Жирный (Ctrl+B)",
  [LocalizationKeys.REVIEWS_FORMATTING_ITALIC]: "Курсив (Ctrl+I)",
  [LocalizationKeys.REVIEWS_FORMATTING_UNDERLINE]: "Подчёркнутый (Ctrl+U)",
  [LocalizationKeys.REVIEWS_FORMATTING_STRIKETHROUGH]: "Зачёркнутый",
  [LocalizationKeys.REVIEWS_FORMATTING_HEADING]: "Заголовок",
  [LocalizationKeys.REVIEWS_FORMATTING_QUOTE]: "Цитата",
  [LocalizationKeys.REVIEWS_FORMATTING_LIST]: "Список",
  [LocalizationKeys.REVIEWS_FORMATTING_LINK]: "Ссылка",
  [LocalizationKeys.REVIEWS_VIEW_ALL]: "Посмотреть все",
  [LocalizationKeys.REVIEWS_PAGE_TITLE]: 'Отзывы на "{0}"',
  [LocalizationKeys.REVIEWS_BACK_TO_CONTENT]: "Вернуться к контенту",
  [LocalizationKeys.REVIEWS_SORT_BY_DATE]: "По дате",
  [LocalizationKeys.REVIEWS_SORT_BY_USEFULNESS]: "По полезности",
  [LocalizationKeys.REVIEWS_SORT_BY_REPUTATION]: "По репутации",
  [LocalizationKeys.REVIEWS_SORT_ASC]: "По возрастанию",
  [LocalizationKeys.REVIEWS_SORT_DESC]: "По убыванию",
  [LocalizationKeys.REVIEWS_FILTER_LANGUAGE]: "Язык",
  [LocalizationKeys.REVIEWS_HIDE_NEGATIVE]: "Только с положительной репутацией",
  [LocalizationKeys.REVIEWS_TOTAL_COUNT]: "{0} отзывов",
  [LocalizationKeys.REVIEWS_TITLE]: "Заголовок",
  [LocalizationKeys.REVIEWS_TITLE_PLACEHOLDER]: "Введите заголовок отзыва...",
  [LocalizationKeys.REVIEWS_SAVE_ERROR]:
    "Не удалось сохранить отзыв. Попробуйте ещё раз.",

  [LocalizationKeys.REVIEW_EDIT]: "Редактировать",
  [LocalizationKeys.REVIEW_EDIT_TITLE]: "Редактирование ревью",
  [LocalizationKeys.REVIEW_DELETE]: "Удалить",
  [LocalizationKeys.REVIEW_DELETE_TITLE]: "Удаление ревью",
  [LocalizationKeys.REVIEW_DELETE_CONFIRM_MESSAGE]:
    "Вы действительно хотите удалить своё ревью?",
  [LocalizationKeys.REVIEW_CONFIRM_DELETE]: "Подтверждение удаления",
  [LocalizationKeys.REVIEW_CONFIRM_DELETE_TEXT]:
    "Вы уверены, что хотите удалить этот отзыв? Это действие нельзя отменить.",
  [LocalizationKeys.REVIEW_CANCEL]: "Отмена",
  [LocalizationKeys.REVIEW_AUTHOR_RATING]: "Оценка автора",
  [LocalizationKeys.REVIEW_CREATED_AT]: "Создано",
  [LocalizationKeys.REVIEW_UPDATED_AT]: "Обновлено",
  [LocalizationKeys.REVIEW_LOADING]: "Загрузка отзыва...",
  [LocalizationKeys.REVIEW_ERROR]: "Не удалось загрузить отзыв",
  [LocalizationKeys.REVIEW_NOT_FOUND]: "Отзыв не найден",
  [LocalizationKeys.REVIEW_GO_TO_CONTENT]: "Перейти к контенту",
  [LocalizationKeys.REVIEW_GO_TO_ALL_REVIEWS]: "Все рецензии",
  [LocalizationKeys.REVIEW_TO_CONTENT]: "К контенту",
  [LocalizationKeys.REVIEW_TO_ALL_REVIEWS]: "Ко всем рецензиям",
  [LocalizationKeys.REVIEW_OF]: "Рецензия на",
  [LocalizationKeys.REVIEW_ON]: "о",
  [LocalizationKeys.REVIEW_AUTHOR_GAVE_RATING]: "Оценка",
  [LocalizationKeys.REVIEW_COMMENTS_SECTION]: "Комментарии",
  [LocalizationKeys.REVIEW_COMMENTS_PLACEHOLDER]:
    "Раздел с комментариями будет реализован позже",

  // Comments section keys
  [LocalizationKeys.COMMENTS_SECTION_TITLE]: "Комментарии",
  [LocalizationKeys.COMMENTS_WRITE_COMMENT]: "Комментировать",
  [LocalizationKeys.COMMENTS_REPLY]: "Ответить",
  [LocalizationKeys.COMMENTS_CANCEL]: "Отмена",
  [LocalizationKeys.COMMENTS_PUBLISH]: "Опубликовать комментарий",
  [LocalizationKeys.COMMENTS_EDIT]: "Редактировать",
  [LocalizationKeys.COMMENTS_DELETE]: "Удалить",
  [LocalizationKeys.COMMENTS_SHARE]: "Поделиться",
  [LocalizationKeys.COMMENTS_REPORT]: "Пожаловаться",
  [LocalizationKeys.COMMENTS_VIEW_MORE]: "Показать больше комментариев",
  [LocalizationKeys.COMMENTS_LOAD_MORE_REPLIES]: "Загрузить больше ответов",
  [LocalizationKeys.COMMENTS_SHOW_REPLIES]: "Показать ответы",
  [LocalizationKeys.COMMENTS_HIDE_REPLIES]: "Скрыть ответы",
  [LocalizationKeys.COMMENTS_REPLY_COUNT]: "{0} ответов",
  [LocalizationKeys.COMMENTS_ACTIONS_LABEL]: "Действия с комментарием",
  [LocalizationKeys.COMMENTS_EXPAND]: "Развернуть",
  [LocalizationKeys.COMMENTS_COLLAPSE]: "Свернуть",
  [LocalizationKeys.COMMENTS_PLACEHOLDER]: "Напишите комментарий...",
  [LocalizationKeys.COMMENTS_CREATED_AT]: "Опубликовано",
  [LocalizationKeys.COMMENTS_UPDATED_AT]: "Обновлено",
  [LocalizationKeys.COMMENTS_EDITED]: "(изменено)",
  [LocalizationKeys.COMMENTS_DELETE_CONFIRM]: "Удалить комментарий?",
  [LocalizationKeys.COMMENTS_DELETE_CONFIRM_MESSAGE]:
    "Вы уверены, что хотите удалить этот комментарий? Это действие необратимо.",
  [LocalizationKeys.COMMENTS_SAVE_ERROR]: "Не удалось сохранить комментарий",
  [LocalizationKeys.COMMENTS_DELETE_ERROR]: "Не удалось удалить комментарий",
  [LocalizationKeys.COMMENTS_LOAD_ERROR]: "Не удалось загрузить комментарии",
  [LocalizationKeys.COMMENTS_NO_COMMENTS]:
    "Пока нет комментариев. Станьте первым!",
  [LocalizationKeys.COMMENTS_REPLYING_TO]: "Ответ для",

  // Person page keys
  [LocalizationKeys.PERSON_BIRTH_DATE]: "Дата рождения",
  [LocalizationKeys.PERSON_DEATH_DATE]: "Дата смерти",
  [LocalizationKeys.PERSON_AGE]: "лет",
  [LocalizationKeys.PERSON_YEARS]: "лет",
  [LocalizationKeys.PERSON_GENDER]: "Пол",
  [LocalizationKeys.PERSON_HEIGHT]: "Рост",
  [LocalizationKeys.PERSON_HEIGHT_CM]: "см",
  [LocalizationKeys.PERSON_BIRTH_PLACE]: "Место рождения",
  [LocalizationKeys.PERSON_SPOUSE]: "Супруга",
  [LocalizationKeys.PERSON_BIOGRAPHY]: "Биография",
  [LocalizationKeys.PERSON_KNOWN_FOR]: "Известен по",
  [LocalizationKeys.PERSON_PARTICIPATED_IN]: "Участвовал как",
  [LocalizationKeys.PERSON_FAVOURITE_COUNT]: "Избранное",
  [LocalizationKeys.PERSON_MESSAGE_COUNT]: "Сообщения",

  // Position Type keys
  [LocalizationKeys.POSITION_TYPE_UNSPECIFIED]: "Не указано",
  [LocalizationKeys.POSITION_TYPE_DIRECTOR]: "Режиссёр",
  [LocalizationKeys.POSITION_TYPE_WRITER]: "Сценарист",
  [LocalizationKeys.POSITION_TYPE_ACTOR]: "Актёр",
  [LocalizationKeys.POSITION_TYPE_PRODUCER]: "Продюсер",
  [LocalizationKeys.POSITION_TYPE_CINEMATOGRAPHER]: "Оператор",
  [LocalizationKeys.POSITION_TYPE_EDITOR]: "Монтажёр",
  [LocalizationKeys.POSITION_TYPE_COMPOSER]: "Композитор",
  [LocalizationKeys.POSITION_TYPE_VOICE_ACTOR]: "Актёр озвучки",

  // Pagination keys
  [LocalizationKeys.PAGINATION_PREVIOUS]: "←",
  [LocalizationKeys.PAGINATION_NEXT]: "→",
  [LocalizationKeys.PAGINATION_FIRST]: "Первая",
  [LocalizationKeys.PAGINATION_LAST]: "Последняя",

  // Sort keys
  [LocalizationKeys.SORT_BY]: "Сортировать по",
  [LocalizationKeys.SORT_BY_NEWEST]: "Новые",
  [LocalizationKeys.SORT_BY_OLDEST]: "Старые",
  [LocalizationKeys.SORT_BY_POPULAR]: "Популярные",
  [LocalizationKeys.SORT_BY_RATING]: "Рейтинг",
  [LocalizationKeys.SORT_NEWEST]: "Новые",
  [LocalizationKeys.SORT_OLDEST]: "Старые",
  [LocalizationKeys.SORT_HIGHEST_REPUTATION]: "С высокой репутацией",
  [LocalizationKeys.SORT_LOWEST_REPUTATION]: "С низкой репутацией",
  [LocalizationKeys.SORT_MOST_USEFUL]: "Самые полезные",
  [LocalizationKeys.SORT_LEAST_USEFUL]: "Наименее полезные",
  [LocalizationKeys.SORT_HIGHEST_RATING]: "Высокий рейтинг",
  [LocalizationKeys.SORT_LOWEST_RATING]: "Низкий рейтинг",
  [LocalizationKeys.SORT_NAME_ASC]: "От А до Я",
  [LocalizationKeys.SORT_NAME_DESC]: "От Я до А",

  // Collections list keys
  [LocalizationKeys.COLLECTIONS_NO_COLLECTIONS_FOUND]: "Коллекции не найдены",
  [LocalizationKeys.COLLECTIONS_LOADING]: "Загрузка коллекций...",
  [LocalizationKeys.COLLECTIONS_ONLY_MY_COLLECTIONS]: "Только мои коллекции",
  [LocalizationKeys.COLLECTIONS_OF_CONTENT]: "Коллекции с",
  [LocalizationKeys.COLLECTIONS_TO_ALL_COLLECTIONS]: "Ко всем коллекциям",

  // User collections page keys
  [LocalizationKeys.USER_COLLECTIONS_TOTAL]: "Всего коллекций",
  [LocalizationKeys.USER_COLLECTIONS_AVG_REPUTATION]: "Ср. репутация",
  [LocalizationKeys.USER_COLLECTIONS_TOTAL_FAVOURITES]: "Всего избранного",
  [LocalizationKeys.USER_COLLECTIONS_TOTAL_COMMENTS]: "Всего комментариев",
  [LocalizationKeys.USER_COLLECTIONS_EMPTY]: "Пока нет коллекций",
  [LocalizationKeys.USER_COLLECTIONS_TITLE]: "Коллекции",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_DATE]: "Сортировать по дате",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_REPUTATION]:
    "Сортировать по репутации",
  [LocalizationKeys.USER_COLLECTIONS_SORT_BY_USEFULNESS]:
    "Сортировать по полезности",

  // User profile page keys
  [LocalizationKeys.USER_PAGE_FOLLOW]: "Подписаться",
  [LocalizationKeys.USER_PAGE_FOLLOWING]: "Подписан",
  [LocalizationKeys.USER_PAGE_UNFOLLOW]: "Отписаться",
  [LocalizationKeys.USER_PAGE_FOLLOWERS]: "Подписчики",
  [LocalizationKeys.USER_PAGE_REVIEWS]: "Рецензии",
  [LocalizationKeys.USER_PAGE_COLLECTIONS]: "Коллекции",
  [LocalizationKeys.USER_PAGE_LIBRARY]: "Библиотека",
  [LocalizationKeys.USER_PAGE_MY_LIBRARY]: "Моя библиотека",
  [LocalizationKeys.USER_PAGE_FAVOURITES]: "Избранное",
  [LocalizationKeys.USER_PAGE_MY_FAVOURITES]: "Моё избранное",
  [LocalizationKeys.USER_PAGE_CREATED_COLLECTIONS]: "Созданные коллекции",
  [LocalizationKeys.USER_PAGE_VIEW_ALL_COLLECTIONS]: "Посмотреть все коллекции",
  [LocalizationKeys.USER_PAGE_TOP_REVIEWS]: "Лучшие рецензии",
  [LocalizationKeys.USER_PAGE_VIEW_ALL_REVIEWS]: "Посмотреть все рецензии",
  [LocalizationKeys.USER_PAGE_ACTIVITY_CALENDAR]: "Календарь активности",
  [LocalizationKeys.USER_PAGE_ACTIVITY_CALENDAR_DESC]:
    "Календарь активности в стиле GitHub, показывающий вовлеченность пользователя.",
  [LocalizationKeys.USER_PAGE_PLATFORM_HISTORY]:
    "История активности на платформе",
  [LocalizationKeys.USER_PAGE_PLATFORM_HISTORY_DESC]:
    "Последние действия и взаимодействия на платформе.",
  [LocalizationKeys.USER_PAGE_ACIVEMENT_SECTION]: "Достижения пользователя",
  [LocalizationKeys.USER_PAGE_ACIVEMENT_SECTION_DESC]:
    "Компонент с горизонтальным скролом, содержащий полученные ачивки пользователя",

  // User follows page keys
  [LocalizationKeys.USER_FOLLOWS_PAGE_FOLLOWERS_TAB]: "Подписчики",
  [LocalizationKeys.USER_FOLLOWS_PAGE_FOLLOWING_TAB]: "Подписки",
  [LocalizationKeys.USER_FOLLOWS_PAGE_NO_FOLLOWERS]: "Пока нет подписчиков",
  [LocalizationKeys.USER_FOLLOWS_PAGE_NO_FOLLOWING]:
    "Пока не подписан ни на кого",
  [LocalizationKeys.USER_FOLLOWS_PAGE_LOADING]: "Загрузка пользователей...",

  // User stats keys
  [LocalizationKeys.USER_STATS_OVERVIEW]: "Обзор статистики",
  [LocalizationKeys.USER_STATS_REVIEWS]: "Рецензии",
  [LocalizationKeys.USER_STATS_COLLECTIONS]: "Коллекции",
  [LocalizationKeys.USER_STATS_COMMENTS]: "Комментарии",
  [LocalizationKeys.USER_STATS_FAVOURITES]: "Избранное",
  [LocalizationKeys.USER_STATS_TOTAL_CONSUMED]: "Всего потреблено",
  [LocalizationKeys.USER_STATS_ITEMS]: "Элементов",
  [LocalizationKeys.USER_STATS_WATCH_TIME]: "Время просмотра",
  [LocalizationKeys.USER_STATS_PAGES_READ]: "Страниц прочитано",
  [LocalizationKeys.USER_STATS_DAYS]: "дн.",
  [LocalizationKeys.USER_STATS_HOURS]: "ч.",
  [LocalizationKeys.USER_STATS_MINUTES]: "мин.",
  [LocalizationKeys.USER_STATS_PAGES]: "стр.",

  // Favourite widget keys
  [LocalizationKeys.FAVOURITE_WIDGET_NO_CONTENT]:
    "У пользователя нет избранного контента",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_CONTENT_CURRENT_USER]:
    "У вас нет избранного контента",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_PEOPLE]:
    "У пользователя нет избранных персон",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_PEOPLE_CURRENT_USER]:
    "У вас нет избранных персон",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_COLLECTIONS]:
    "У пользователя нет избранных коллекций",
  [LocalizationKeys.FAVOURITE_WIDGET_NO_COLLECTIONS_CURRENT_USER]:
    "У вас нет избранных коллекций",

  // Library widget keys
  [LocalizationKeys.LIBRARY_WIDGET_NO_CONTENT]: "У пользователя нет {0} {1}",
  [LocalizationKeys.LIBRARY_WIDGET_NO_CONTENT_CURRENT_USER]:
    "У вас нет {0} {1}",

  // Toast notification keys
  [LocalizationKeys.TOAST_AUTH_WELCOME_BACK]: "С возвращением!",
  [LocalizationKeys.TOAST_AUTH_ACCOUNT_CREATED]:
    "Аккаунт успешно создан! Добро пожаловать!",
  [LocalizationKeys.TOAST_AUTH_SESSION_EXPIRED]:
    "Сессия истекла. Пожалуйста, войдите снова.",
  [LocalizationKeys.TOAST_AUTH_PROFILE_LOAD_FAILED]:
    "Не удалось загрузить профиль пользователя",

  [LocalizationKeys.TOAST_DEV_MOCK_DATA_LOADED]:
    "Режим разработки: Используются моковые данные",

  [LocalizationKeys.TOAST_REVIEW_CREATED]: "Отзыв успешно создан!",
  [LocalizationKeys.TOAST_REVIEW_SAVED]: "Рецензия успешно сохранена!",
  [LocalizationKeys.TOAST_REVIEW_FILL_REQUIRED]:
    "Пожалуйста, заполните название и текст",

  [LocalizationKeys.TOAST_COLLECTION_SAVED]: "Коллекция успешно сохранена!",
  [LocalizationKeys.TOAST_COLLECTION_UPDATED]: "Коллекция успешно обновлена!",
  [LocalizationKeys.TOAST_COLLECTION_DELETED]: "Коллекция успешно удалена!",
  [LocalizationKeys.TOAST_COLLECTION_TITLE_REQUIRED]:
    "Пожалуйста, введите название коллекции",

  [LocalizationKeys.TOAST_AFFILIATE_SAVED]:
    "Настройки партнёрских ссылок успешно сохранены!",

  [LocalizationKeys.TOAST_ERROR_GENERIC]: "Произошла непредвиденная ошибка",
  [LocalizationKeys.TOAST_ERROR_NETWORK]:
    "Ошибка сети. Проверьте подключение к интернету.",
  [LocalizationKeys.TOAST_ERROR_SAVE_FAILED]: "Не удалось сохранить изменения",

  [LocalizationKeys.TOAST_VALIDATION_REQUIRED_FIELDS]:
    "Пожалуйста, заполните все обязательные поля",
  [LocalizationKeys.TOAST_VALIDATION_FILL_ALL_FIELDS]:
    "Пожалуйста, заполните все поля правильно",

  // Pin action toast keys
  [LocalizationKeys.TOAST_CONTENT_PINNED]: "Контент успешно закреплён!",
  [LocalizationKeys.TOAST_CONTENT_UNPINNED]: "Контент успешно откреплён!",
  [LocalizationKeys.TOAST_CONTENT_PIN_ERROR]: "Не удалось закрепить контент",
  [LocalizationKeys.TOAST_CONTENT_UNPIN_ERROR]: "Не удалось открепить контент",

  // Follow action toast keys
  [LocalizationKeys.TOAST_USER_FOLLOWED]: "Вы успешно подписались!",
  [LocalizationKeys.TOAST_USER_UNFOLLOWED]: "Вы успешно отписались!",
  [LocalizationKeys.TOAST_USER_FOLLOW_ERROR]: "Не удалось подписаться",
  [LocalizationKeys.TOAST_USER_UNFOLLOW_ERROR]: "Не удалось отписаться",

  // Edit/Delete action toast keys
  [LocalizationKeys.TOAST_ITEM_DELETED]: "Элемент успешно удалён!",
  [LocalizationKeys.TOAST_ITEM_DELETE_ERROR]: "Не удалось удалить элемент",
  [LocalizationKeys.TOAST_ITEM_UPDATED]: "Элемент успешно обновлён!",
  [LocalizationKeys.TOAST_ITEM_UPDATE_ERROR]: "Не удалось обновить элемент",

  // Favourite action toast keys
  [LocalizationKeys.TOAST_FAVOURITE_ADDED]: "Добавлено в избранное!",
  [LocalizationKeys.TOAST_FAVOURITE_REMOVED]: "Удалено из избранного",
  [LocalizationKeys.TOAST_FAVOURITE_MUTED]: "Уведомления отключены",
  [LocalizationKeys.TOAST_FAVOURITE_UNMUTED]: "Уведомления включены",
  [LocalizationKeys.TOAST_FAVOURITE_ADD_ERROR]:
    "Не удалось добавить в избранное",
  [LocalizationKeys.TOAST_FAVOURITE_REMOVE_ERROR]:
    "Не удалось удалить из избранного",
  [LocalizationKeys.TOAST_FAVOURITE_UPDATE_ERROR]:
    "Не удалось обновить настройки избранного",

  // Rating action toast keys
  [LocalizationKeys.TOAST_RATING_ADDED]: "Оценка добавлена!",
  [LocalizationKeys.TOAST_RATING_UPDATED]: "Оценка обновлена!",
  [LocalizationKeys.TOAST_RATING_REMOVED]: "Оценка удалена",
  [LocalizationKeys.TOAST_RATING_ERROR]: "Не удалось сохранить оценку",

  // Consume action toast keys
  [LocalizationKeys.TOAST_CONSUME_WATCHING]: "Отмечено как смотрю!",
  [LocalizationKeys.TOAST_CONSUME_WATCHED]: "Отмечено как просмотрено!",
  [LocalizationKeys.TOAST_CONSUME_DELAYED]: "Добавлено в отложенное",
  [LocalizationKeys.TOAST_CONSUME_TRASH]: "Перемещено в брошенное",
  [LocalizationKeys.TOAST_CONSUME_REMOVED]: "Статус удалён",
  [LocalizationKeys.TOAST_CONSUME_ERROR]: "Не удалось обновить статус",

  // Reputation action toast keys
  [LocalizationKeys.TOAST_REPUTATION_LIKED]: "Вы поставили лайк!",
  [LocalizationKeys.TOAST_REPUTATION_DISLIKED]: "Вы поставили дизлайк",
  [LocalizationKeys.TOAST_REPUTATION_REMOVED]: "Оценка убрана",
  [LocalizationKeys.TOAST_REPUTATION_ERROR]: "Не удалось сохранить оценку",

  // Share action toast keys
  [LocalizationKeys.TOAST_LINK_COPIED]: "Ссылка скопирована в буфер обмена",
  [LocalizationKeys.TOAST_LINK_COPY_ERROR]: "Не удалось скопировать ссылку",

  ...ruRegionTranslations,
} as Translations;
